var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/UserClassifierRepo/Migration/Migration.ts";
import * as t from 'io-ts';
import { ApiCallService } from '@gmini/api-call-service';
import { ApiDomain } from '../../domain';
import { UserClassifier } from '../UserClassifier';
export var Migrate = ApiCallService.create({
  name: 'migrate',
  parentDomain: ApiDomain,
  result: t.recursion('result', function () {
    return UserClassifier.io;
  }),
  getKey: ['classifierId', 'classifierVersion', 'sourceClassifierId', 'currentSourceClassifierVersion', 'newSourceClassifierVersion']
});
export var migrate = Migrate.createContext();